import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

import LandingPage from './components/LandingPage/LandingPage';
import VisualizerPage from './components/VisualizerPage/VisualizerPage';


import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import TestPage from './components/TestPage/TestPage';
import { visualizerActions } from './store';
import { getJsonFromSheet } from './components/Helpers/SheetsHelper';


const router = createBrowserRouter([
  { path: '/', element: <><LandingPage /> </> },
  { path: '/visualizer/package/:packageName/spec/:specifier/sel/:selString', element: <><VisualizerPage /> </> },
  { path: '/test', element: <TestPage/> },
])

function App() {
  const dispatch = useDispatch();
  const popUpModalActive = useSelector((state) => state.ui.popUpModalActive);

  getJsonFromSheet('/data/Packages.xlsx').then(jsonData => {
    dispatch(visualizerActions.setPackageData(jsonData));
  })

  return (
    <div className={`App ${ popUpModalActive ? 'blur' : ''}`} >
      <RouterProvider router={router} />
      <LoadingScreen />
    </div>
  );
}

export default App;


